<template lang="pug">
	.widget-container-background(:class="theme" v-if="ready")
		.widget-container
			.text-right
				a#advertiser-disclosure(href="javascript: void(0)")
					| Advertiser disclosure
				b-tooltip(target="advertiser-disclosure" placement="topright" triggers="click blur")
					.tooltip-info
						p
							| Five years before MIP can be dropped if your loan term is greater than 15 years, and MIP can be dropped only if the loan balance reaches 78 percent of the home's original price—the purchase price stated on your mortgage documents. If your FHA loan originated after June 2013, however, new rules will apply. If your original LTV is 90 percent or less, you'll pay MIP for 11 years. If your LTV is greater than 90 percent, you'll pay MIP throughout the life of the loan
			.title-select-container
				h1 Compare 529 College Savings Plans
				.select-state-dropdown
					select(v-model="selectedStateIdFromSelect" @change="clickFromSelect()")
						option(value="-" disabled) Select your state
						option(v-for="state of states" :value="state.string_id")
							| {{state.name}}
					span.arrow-down
			div.plans-container(v-if="showPlans")
				div(v-if="showEnrollNowPlusOnly")
					p(v-if="enrollNowPlusPlans[0].deduction_info.has_deduction || enrollNowPlusPlans[0].deduction_info.has_credit")
						| Congratulations! {{state.name}} offers a state tax {{enrollNowPlusPlans[0].deduction_info.has_deduction ? "deduction" : "credit"}} for contributing to your state's 529 plan.
					p(v-if="!enrollNowPlusPlans[0].deduction_info.has_deduction && !enrollNowPlusPlans[0].deduction_info.has_credit")
						| Congratulations! It’s easy to save for college with a 529 plan from {{state.name}}.

					sfc-plan-card-v1.mt-4(v-if="plan.excluded_states_ids.indexOf(selectedStateId) == -1" v-for="plan of enrollNowPlusPlans" :plan="plan" :key="plan.id" :state-id="selectedStateId" @click="trackEnrollNowClick(plan)" :statePlan="statePlans[selectedStateId][0]")

				div(v-if="showEnrollNowOnly")
					//- p
						| The state of {{state.name}} offers the following plan{{enrollNowPlans.length > 1 ? 's' : ''}}

					sfc-plan-card-v1.mt-4(v-if="plan.excluded_states_ids.indexOf(selectedStateId) == -1" v-for="plan of enrollNowPlans" :plan="plan" open-plan="true" :state-id="selectedStateId" @click="trackEnrollNowClick(plan)" :statePlan="statePlans[selectedStateId][0]")

					p.mt-4 {{copySentence}}

					sfc-plan-card-v1.mt-4(v-for="(plan, i) of nationalPlans" :show-alternative-logo="true" :plan="plan" :key="plan.id" :state-id="selectedStateId" v-if="i < 2 && plan.excluded_states_ids.indexOf(selectedStateId) == -1 && !isStatePlan(plan)" @click="trackEnrollNowClick(plan)" :statePlan="statePlans[selectedStateId][0]")

				div(v-if="!showEnrollNowPlusOnly && !showEnrollNowOnly")
					p(v-if="statePlans[selectedStateId].length > 0")
						| The state of {{state.name}} offers the following plan{{statePlans[selectedStateId].length > 1 ? 's' : ''}}
					.plans-content
						sfc-plan-card-v1(v-for="plan of statePlans[selectedStateId]" :plan="plan" :open-plan="false" :state-id="selectedStateId" :statePlan="statePlans[selectedStateId][0]")
					.show-plans-section.mt-4
						p
							| {{copySentence}}
						sfc-plan-card-v1.mt-4(v-for="(plan, i) of nationalPlans" :show-alternative-logo="true" :plan="plan" :key="plan.id" :state-id="selectedStateId" v-if="i < 2 && plan.excluded_states_ids.indexOf(selectedStateId) == -1 && !isStatePlan(plan)" @click="trackEnrollNowClick(plan)" :statePlan="statePlans[selectedStateId][0]")
				//- p.mt-4.mb-0.disclosure.text-center Rankings and ratings provided by savingforcollege.com
</template>

<script>
import axios from "axios";
import SfcPlanCardV1 from "./sfc-plan-card.vue";
import { track, trackAnalyticsAction } from "./../../track.js";
import { queryParams } from "./../../query_params.js";

export default {
	props: {
		statePlans: {},
		stateTaxes: {},
		nationalPlans: {},
		nonNationalPlans: {},
		company: { default: "Unkown" }
	},

	watch: {},

	components: {
		SfcPlanCardV1
	},


	created() {
		this.urlVars = queryParams();

		if (this.urlVars.colorMain) {
			this.colorMain = this.urlVars.colorMain;
		}
		if (this.urlVars.colorStroke) {
			this.colorStroke = this.urlVars.colorStroke;
		}
		if (this.urlVars.company) {
			this.localCompany = this.urlVars.company;
		}
		if (this.urlVars.theme){
			this.theme = "theme-" + this.urlVars.theme;
		}
	},

	mounted() {
		this.params = queryParams();
		this.widgetIdentifier = this.params.widgetIdentifier
		if (this.urlVars.stateId) {
			if (this.urlVars.stateId == "auto") {
				const query = `
					query{
						no_graphql_cache()
						state_from_ip(){
							id
							sfc_id
							name
							slug
						}
					}
				`;

				axios
					.post(`${process.env.SFC_URL}/graphql`, { query })
					.then(response => {
						let responseState = response.data.data.state_from_ip;
						this.selectedStateIdFromSelect = responseState.id;
						this.mapClicked(responseState.id);
						this.ready = true;
					});
			} else {
				let stateId = this.urlVars.stateId.toUpperCase();
				if (this.states.find(s => s.string_id == stateId)) {
					this.mapClicked(stateId);
					this.ready = true;
				}
			}
		} else {
			this.ready = true;
		}
		this.sendHeight();
		setTimeout(() => {
			this.sendHeight();
		}, 300)

		this.$nextTick(function() {
			window.addEventListener("resize", this.sendHeight())
		});
	},

	data() {
		let selectedStateId = undefined;

		let states = [
			{
				id: 1,
				name: "Alabama",
				string_id: "AL"
			},
			{
				id: 2,
				name: "Alaska",
				string_id: "AK"
			},
			{
				id: 3,
				name: "Arizona",
				string_id: "AZ"
			},
			{
				id: 4,
				name: "Arkansas",
				string_id: "AR"
			},
			{
				id: 5,
				name: "California",
				string_id: "CA"
			},
			{
				id: 6,
				name: "Colorado",
				string_id: "CO"
			},
			{
				id: 7,
				name: "Connecticut",
				string_id: "CT"
			},
			{
				id: 8,
				name: "Delaware",
				string_id: "DE"
			},
			{
				id: 9,
				name: "District of Columbia",
				string_id: "DC"
			},
			{
				id: 10,
				name: "Florida",
				string_id: "FL"
			},
			{
				id: 11,
				name: "Georgia",
				string_id: "GA"
			},
			{
				id: 12,
				name: "Hawaii",
				string_id: "HI"
			},
			{
				id: 13,
				name: "Idaho",
				string_id: "ID"
			},
			{
				id: 14,
				name: "Illinois",
				string_id: "IL"
			},
			{
				id: 15,
				name: "Indiana",
				string_id: "IN"
			},
			{
				id: 16,
				name: "Iowa",
				string_id: "IA"
			},
			{
				id: 17,
				name: "Kansas",
				string_id: "KS"
			},
			{
				id: 18,
				name: "Kentucky",
				string_id: "KY"
			},
			{
				id: 19,
				name: "Louisiana",
				string_id: "LA"
			},
			{
				id: 20,
				name: "Maine",
				string_id: "ME"
			},
			{
				id: 21,
				name: "Maryland",
				string_id: "MD"
			},
			{
				id: 22,
				name: "Massachusetts",
				string_id: "MA"
			},
			{
				id: 23,
				name: "Michigan",
				string_id: "MI"
			},
			{
				id: 24,
				name: "Minnesota",
				string_id: "MN"
			},
			{
				id: 25,
				name: "Mississippi",
				string_id: "MS"
			},
			{
				id: 26,
				name: "Missouri",
				string_id: "MO"
			},
			{
				id: 27,
				name: "Montana",
				string_id: "MT"
			},
			{
				id: 28,
				name: "Nebraska",
				string_id: "NE"
			},
			{
				id: 29,
				name: "Nevada",
				string_id: "NV"
			},
			{
				id: 30,
				name: "New Hampshire",
				string_id: "NH"
			},
			{
				id: 31,
				name: "New Jersey",
				string_id: "NJ"
			},
			{
				id: 32,
				name: "New Mexico",
				string_id: "NM"
			},
			{
				id: 33,
				name: "New York",
				string_id: "NY"
			},
			{
				id: 34,
				name: "North Carolina",
				string_id: "NC"
			},
			{
				id: 35,
				name: "North Dakota",
				string_id: "ND"
			},
			{
				id: 36,
				name: "Ohio",
				string_id: "OH"
			},
			{
				id: 37,
				name: "Oklahoma",
				string_id: "OK"
			},
			{
				id: 38,
				name: "Oregon",
				string_id: "OR"
			},
			{
				id: 39,
				name: "Pennsylvania",
				string_id: "PA"
			},
			{
				id: 40,
				name: "Rhode Island",
				string_id: "RI"
			},
			{
				id: 41,
				name: "South Carolina",
				string_id: "SC"
			},
			{
				id: 42,
				name: "South Dakota",
				string_id: "SD"
			},
			{
				id: 43,
				name: "Tennessee",
				string_id: "TN"
			},
			{
				id: 44,
				name: "Texas",
				string_id: "TX"
			},
			{
				id: 45,
				name: "Utah",
				string_id: "UT"
			},
			{
				id: 46,
				name: "Vermont",
				string_id: "VT"
			},
			{
				id: 47,
				name: "Virginia",
				string_id: "VA"
			},
			{
				id: 48,
				name: "Washington",
				string_id: "WA"
			},
			{
				id: 49,
				name: "West Virginia",
				string_id: "WV"
			},
			{
				id: 50,
				name: "Wisconsin",
				string_id: "WI"
			},
			{
				id: 51,
				name: "Wyoming",
				string_id: "WY"
			}
		];

		let state = "selected";

		return {
			selectedStateId,
			selectedStateIdFromSelect: "-",
			states,
			state,
			deduction: {},
			showPlans: false,
			openPlan: true,
			urlVars: {},
			theme: "",
			colorMain: "a7d8a4",
			colorStroke: "000000",
			mode: "state_detect",
			ready: false,
			params: {},
			sfcUrl: process.env.SFC_URL,
			widgetIdentifier: undefined
		};
	},

	methods: {
		isStatePlan(plan) {
			for (let enrollNowPlan of this.enrollNowPlans) {
				if (plan.id == enrollNowPlan.id) {
					return true;
				}
			}
			return false;
		},
		clearState() {
			track(
				"STATE_SELECT",
				"CHANGE_STATE",
				undefined,
				this.selectedStateId
			);
			this.sendHeight()
			this.showPlans = false;
			this.state = "selected";
			this.$emit('shuffle')
		},

		clickFromSelect() {
			if (
				this.states.find(
					s => s.string_id == this.selectedStateIdFromSelect
				)
			) {
				this.mapClicked(this.selectedStateIdFromSelect);
			}
		},

		mapClicked(event) {
			if (event == undefined) {
				this.selectedStateId = this.state.string_id;
			} else {
				this.selectedStateId = event;
			}
			for (let index = 0; index < this.states.length; index++) {
				if (this.selectedStateId == this.states[index].string_id) {
					this.state = this.states[index];
					break;
				}
			}
			this.deduction = this.stateTaxes[this.state.string_id].deductions;
			track(
				"STATE_SELECT",
				this.isMobile() ? "MOBILE_DROPDOWN_CLICK" : "MAP_CLICK",
				undefined,
				this.selectedStateId
			);
			trackAnalyticsAction(
				"External Widgets",
				`${this.params.company || "Unknown"} - Enroll now 529 V2`,
				"State Click"
			);
			this.sendHeight();
			this.showPlans = true;
		},

		trackEnrollNowClick(plan) {
			if (plan.has_enroll_now_plus) {
				trackAnalyticsAction(
					"External Widgets",
					`${this.params.company || "Unknown"} - Enroll now 529 V2`,
					`Enroll Now Plus Click - ${plan.name}`
				);
			} else {
				trackAnalyticsAction(
					"External Widgets",
					`${this.params.company || "Unknown"} - Enroll now 529 V2`,
					`Enroll Now Click - ${plan.name}`
				);
			}
		},

		isMobile() {
			return document.documentElement.clientWidth < 768;
		},

		sendHeight(left = 5) {
			let appDiv = document.getElementById("app")
			if (appDiv) {
				window.top.postMessage({widgetIdentifier: this.widgetIdentifier, height: appDiv.scrollHeight + 0}, "*")
				setTimeout(() => {
					window.top.postMessage({widgetIdentifier: this.widgetIdentifier, height: appDiv.scrollHeight + 0}, "*")
					if (left > 0) {
						this.sendHeight(left - 1)
					}
				}, 200)
			} else {
				setTimeout (() => {
					this.sendHeight()
				}, 100)
			}
		},

		hasTaxBenefit(state) {
			if (state == "selected") return false;
			return this.stateTaxes[state.string_id].has_state_tax_deduction;
		}
	},

	computed: {
		copySentence(){
			if(this.statePlans[this.selectedStateId].length > 0){
				let plan = this.statePlans[this.selectedStateId][0]
				if(!plan.deduction_info.has_deduction && !plan.deduction_info.has_credit){
					return `${this.state.name} doesn't offer a state tax benefit. Consider these top-rated plans available to ${this.state.name} residents.`
				}else{
					if(plan.deduction_info.has_parity){
						return `Did you know? Your state tax benefit can be used with 529 plans from any state. Compare ${this.state.name}'${this.state.name.slice(-1) == 's' ? '' : 's'} plan with other top-rated plans nationwide:`
					}
					return `Remember that you can open plans from any state. Compare ${this.state.name}'${this.state.name.slice(-1) == 's' ? '' : 's'} plan with other top-rated plans nationwide:`
				}

			}
			return `${this.state.name} doesn't offer a 529 plan. Compare top-rated plans nationwide below:`
		},
		showEnrollNowPlusOnly(){
			let valueToReturn = false
			for(let plan of this.statePlans[this.selectedStateId]){
				if(plan.has_enroll_now_plus && plan.excluded_states_ids.indexOf(this.selectedStateId) == -1){
					valueToReturn = true
				}
			}
			return valueToReturn;
		},

		enrollNowPlusPlans() {
			let plans = [];
			for (let plan of this.statePlans[this.selectedStateId]) {
				if (plan.has_enroll_now_plus && plan.excluded_states_ids.indexOf(this.selectedStateId) == -1) {
					plans.push(plan);
				}
			}
			return plans;
		},

		showEnrollNowOnly() {
			let valueToReturn = false;
			for (let plan of this.statePlans[this.selectedStateId]) {
				if (plan.has_enroll_now) {
					valueToReturn = true;
				}
			}
			return valueToReturn && !this.showEnrollNowPlusOnly;
		},

		enrollNowPlans() {
			let plans = [];
			for (let plan of this.statePlans[this.selectedStateId]) {
				if (plan.has_enroll_now) {
					plans.push(plan);
				}
			}
			return plans;
		}
	}

}
</script>

<style lang="stylus" scoped>
	@font-face {
		font-family: 'Cabin'
		font-weight: normal;
		src: url('~src/assets/fonts/Cabin-Regular.ttf'); /* IE9 Compat Mode */
		src: url('~src/assets/fonts/Cabin-Regular.ttf') format('ttf'),
	}
	@font-face {
		font-family: 'Cabin-semi-bold'
		font-weight: 300;
		src: url('~src/assets/fonts/Cabin-SemiBold.ttf'); /* IE9 Compat Mode */
		src: url('~src/assets/fonts/Cabin-SemiBold.ttf') format('ttf'),
	}
	@font-face {
		font-family: 'Cabin'
		font-weight: 600;
		src: url('~src/assets/fonts/Cabin-Medium.ttf'); /* IE9 Compat Mode */
		src: url('~src/assets/fonts/Cabin-Medium.ttf') format('ttf'),
	}
	@font-face {
		font-family: 'Source Sans Pro'
		font-weight: normal;
		src: url('~src/assets/fonts/SourceSansPro-Regular.ttf'); /* IE9 Compat Mode */
		src: url('~src/assets/fonts/SourceSansPro-Regular.ttf') format('ttf'),
	}



	.theme-investopedia
		background: #fff
		color: #222
		font-family: 'Source Sans Pro'
		min-height: 100%
		line-height: 15px;
		h1
			font-style: normal;
			font-weight: 500;
			font-size: 26px;
			line-height: 28px;
			margin-bottom: 15px
		a
			font-style: normal;
			font-weight: normal;
			font-size: 12px;
			line-height: 16px;
			color: #246FC8
		p
			font-size: 17px;
			line-height: 26px;
		select
			border: 1px solid #A3A6B3;
			box-sizing: border-box;
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			box-shadow: none;
			-webkit-box-shadow: none;
			-moz-box-shadow: none;
			background-color: transparent;
			padding: 7px 13px;
			font-size: 17px;
			line-height: 26px;
			color: #191919;

		.widget-container
			max-width: 608px
			margin 0 auto
			padding 15px 10px

		.title-select-container
			display flex
			align-items center
			justify-content space-between
			h1
				margin 0
				font-weight 600
				font-family 'Cabin', sans-serif
				color #191919
			.arrow-down
				border-top: 6px solid #777777;
				top: 18px
				right: 13px
			.select-state-dropdown
				min-width 185px
				margin 0
				position relative
				select
					display block
					width 100%
		.disclosure
			font-size: 12px;
			line-height: 16px;
			text-align: center;
			color: #444444;

		@media (max-width 604px)
			.title-select-container
				display block
				.select-state-dropdown
					margin-top 10px
			.plans-container
				margin-top 30px




</style>
